import { FormField, ValidationError } from "./CreateGestanteForm.styles";
import OrientacaoSexualOptions from "../../enums/OrientacaoSexual";
import IdentidadeGeneroOptions from "../../enums/IdentidadeGenero";

export const MSG_OUTRO_SEM_TEXTO = "Por favor, descreva a opção personalizada";
// Mesmas mensagens do backend (schemas.py), que também valida a obrigatoriedade
export const MSG_ORIENTACAO_OBRIGATORIA = "Selecione uma opção de orientação sexual";
export const MSG_IDENTIDADE_OBRIGATORIA = "Selecione uma opção de identidade de gênero";
const IDADE_MINIMA_APRESENTACAO = 18;

export const IDENTIDADE_INITIAL_STATE = {
  orientacao_sexual: "",
  orientacao_sexual_other: "",
  identidade_genero: "",
  identidade_genero_other: "",
};

// Estado inicial da edição a partir do payload da gestante
export const identidadeStateFromGestante = (gestante) => ({
  orientacao_sexual:
    gestante?.orientacao_sexual && gestante.orientacao_sexual !== "NAO_INFORMADO"
      ? gestante.orientacao_sexual
      : "",
  orientacao_sexual_other: gestante?.orientacao_sexual_other || "",
  identidade_genero:
    gestante?.identidade_genero && gestante.identidade_genero !== "NAO_INFORMADO"
      ? gestante.identidade_genero
      : "",
  identidade_genero_other: gestante?.identidade_genero_other || "",
});

// Regra de idade definida pelo P.O. (US-102684): < 18 anos não apresenta os
// campos; sem data de nascimento, leitura protetiva (não apresenta). A partir
// de 18 anos os campos são exibidos e obrigatórios — a mesma condição governa
// "exibe" e "exige"
export const podeApresentarIdentidade = (dataNascimento) => {
  if (!dataNascimento) return false;
  const nascimento = new Date(`${String(dataNascimento).slice(0, 10)}T00:00:00`);
  if (Number.isNaN(nascimento.getTime())) return false;
  const hoje = new Date();
  let idade = hoje.getFullYear() - nascimento.getFullYear();
  const aniversarioPendente =
    hoje.getMonth() < nascimento.getMonth() ||
    (hoje.getMonth() === nascimento.getMonth() && hoje.getDate() < nascimento.getDate());
  if (aniversarioPendente) idade -= 1;
  return idade >= IDADE_MINIMA_APRESENTACAO;
};

// US-102684: os dois selects são obrigatórios (a voluntariedade fica na opção
// "Prefiro não informar"); "Outro" continua exigindo o texto livre. Só é
// chamada quando a seção está habilitada (flag ligada e idade >= 18)
export const validarIdentidade = (values) => {
  const errors = {};
  if (!values.orientacao_sexual) {
    errors.orientacao_sexual = MSG_ORIENTACAO_OBRIGATORIA;
  } else if (
    values.orientacao_sexual === "OUTRO" &&
    !values.orientacao_sexual_other.trim()
  ) {
    errors.orientacao_sexual_other = MSG_OUTRO_SEM_TEXTO;
  }
  if (!values.identidade_genero) {
    errors.identidade_genero = MSG_IDENTIDADE_OBRIGATORIA;
  } else if (
    values.identidade_genero === "OUTRO" &&
    !values.identidade_genero_other.trim()
  ) {
    errors.identidade_genero_other = MSG_OUTRO_SEM_TEXTO;
  }
  return errors;
};

// Envia apenas os campos selecionados; select vazio é omitido do payload,
// o que preserva respostas já registradas (anti-regressão). Com a seção
// habilitada os selects são obrigatórios, então o caminho do vazio só ocorre
// para menores de 18 anos / flag desligada, quando os chamadores nem montam
// o payload de identidade
export const montarPayloadIdentidade = (values) => {
  const payload = {};
  if (values.orientacao_sexual) {
    payload.orientacao_sexual = values.orientacao_sexual;
    if (values.orientacao_sexual === "OUTRO") {
      payload.orientacao_sexual_other = values.orientacao_sexual_other.trim();
    }
  }
  if (values.identidade_genero) {
    payload.identidade_genero = values.identidade_genero;
    if (values.identidade_genero === "OUTRO") {
      payload.identidade_genero_other = values.identidade_genero_other.trim();
    }
  }
  return payload;
};

const IdentidadeGeneroSection = ({ values, onChange, errors = {} }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange(name, value);
  };

  return (
    <>
      <FormField>
        <label htmlFor="orientacao_sexual">
          Orientação sexual *
        </label>
        <select
          id="orientacao_sexual"
          name="orientacao_sexual"
          value={values.orientacao_sexual}
          onChange={handleChange}
        >
          <option value="">Selecione...</option>
          {OrientacaoSexualOptions.map((opcao) => (
            <option key={opcao.value} value={opcao.value}>
              {opcao.label}
            </option>
          ))}
        </select>
        {errors.orientacao_sexual && (
          <ValidationError>{errors.orientacao_sexual}</ValidationError>
        )}
      </FormField>

      {values.orientacao_sexual === "OUTRO" && (
        <FormField>
          <label htmlFor="orientacao_sexual_other">
            Descreva a orientação sexual:
          </label>
          <input
            type="text"
            id="orientacao_sexual_other"
            name="orientacao_sexual_other"
            value={values.orientacao_sexual_other}
            onChange={handleChange}
            maxLength={20}
          />
          {errors.orientacao_sexual_other && (
            <ValidationError>{errors.orientacao_sexual_other}</ValidationError>
          )}
        </FormField>
      )}

      <FormField>
        <label htmlFor="identidade_genero">
          Identidade de gênero *
        </label>
        <select
          id="identidade_genero"
          name="identidade_genero"
          value={values.identidade_genero}
          onChange={handleChange}
        >
          <option value="">Selecione...</option>
          {IdentidadeGeneroOptions.map((opcao) => (
            <option key={opcao.value} value={opcao.value}>
              {opcao.label}
            </option>
          ))}
        </select>
        {errors.identidade_genero && (
          <ValidationError>{errors.identidade_genero}</ValidationError>
        )}
      </FormField>

      {values.identidade_genero === "OUTRO" && (
        <FormField>
          <label htmlFor="identidade_genero_other">
            Descreva a identidade de gênero:
          </label>
          <input
            type="text"
            id="identidade_genero_other"
            name="identidade_genero_other"
            value={values.identidade_genero_other}
            onChange={handleChange}
            maxLength={20}
          />
          {errors.identidade_genero_other && (
            <ValidationError>{errors.identidade_genero_other}</ValidationError>
          )}
        </FormField>
      )}
    </>
  );
};

export default IdentidadeGeneroSection;
